export default __webpack_public_path__ + "static/tradead-67ccbc98037f1cf2c2387df60d47fecc.png";